import styled from 'styled-components'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  position: static;
  color: ${colors.neutralColorLowLight};

  > ol {
    display: flex;
    text-decoration: none;
    margin: 0;
    padding: 0;

    > li {
      display: flex;
      text-decoration: none;
    }
  }
`

export const ContainerIcon = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 0.8rem;
  max-width: 2rem;
  padding-top: 0.5rem;
`

export const Link = styled.a`
  color: ${colors.neutralColorLowLight};
  display: flex;
  text-decoration: none;
  font-family: ${fonts.inter};
  font-size: 1.4rem;
  font-weight: 600;
  margin-right: 0.8rem;
`

export const ButtonIcon = styled.a`
  text-decoration: none;
`
